import API from "../api/manager";
import config from "../api/config";

const createBundle = (data) => {
  return API({
    method: "POST",
    url: config.urls.bundle.createBundle,
    data,
  });
};

const update_bundle = (id, data) => {
  return API({
    method: "PUT",
    url: `${config.urls.bundle.updateBundle}/${id}`,
    data,
  });
};

const delete_bundle = (id, data) => {
  return API({
    method: "PUT",
    url: `${config.urls.bundle.deleteBundleItem}/${id}`,
    data,
  });
};

const getAllBundleDocuments = () => {
  return API({
    method: "GET",
    url: config.urls.bundle.getBundleDocuments,
  });
};

const getBundleDocuments = (query = "") => {
  return API({
    method: "GET",
    url: `${config.urls.bundle.getBundleDocuments}${query}`,
  });
};

const getBundleDocumentById = (id) => {
  return API({
    method: "GET",
    url: `${config.urls.bundle.getBundleDocuments}/${id}`,
  });
};

export default {
  createBundle,
  update_bundle,
  getAllBundleDocuments,
  getBundleDocuments,
  getBundleDocumentById,
  delete_bundle,
};
